interface TreeNode { moduleId: string; moduleCode: string; parentModuleId?: string }

/** Zonas de primer nivel seguidas de sus hijas (un nivel); una hija sin su padre a la vista va suelta. */
export function orderedModules<T extends TreeNode>(mods: T[]): { mod: T; depth: number }[] {
  const byCode = (a: T, b: T) => a.moduleCode.localeCompare(b.moduleCode, undefined, { numeric: true });
  const ids = new Set(mods.map(m => m.moduleId));
  const roots = mods.filter(m => !m.parentModuleId || !ids.has(m.parentModuleId)).sort(byCode);
  return roots.flatMap(root => [
    { mod: root, depth: 0 },
    ...mods.filter(m => m.parentModuleId === root.moduleId).sort(byCode).map(mod => ({ mod, depth: 1 })),
  ]);
}
